import Container from "Components/Container/Container";
import SocialMedia from "./SocialMedia/SocialMedia";

const Hero = ({ data }) => {
  return (
    <div className="scroll-section h-[100vh] lto relative">
      <video
        className="absolute w-[100vw] left-0 top-0 h-[100vh] object-cover z-[0]"
        loop
        muted
        autoPlay
        src={data?.video}
      ></video>

      <Container className={`relative z-[10] h-full flex justify-between `}>
        <div className="h-full flex flex-col justify-end">
          {/* <p className="text-xl text-light mb-4">{data?.title}</p> */}
          <span className="mb-[6rem] block">
            <h1
              className="text-5xl lg:text-7xl text-white bebas uppercase "
              dangerouslySetInnerHTML={{ __html: data?.sub_title }}
            />

            <div className="bg-white h-[3px] w-[4rem]"></div>
          </span>
        </div>
        <SocialMedia />
      </Container>
    </div>
  );
};

export default Hero;
